export default function emitGlobalFileEventWithData(action, data) {
    const ev = new CustomEvent('file-event-with-data', {
        detail: {
            action,
            data
        }
    });
    window.dispatchEvent(ev);
}
